import { LegalPage } from "./LegalPage";
import { LEGAL } from "@/lib/legal";

export default function Terminos() {
  return (
    <LegalPage title="Términos y condiciones">
      <p>
        Bienvenida/o a <strong>{LEGAL.brand}</strong>. Estos términos regulan el uso de la aplicación disponible en <a href={`https://${LEGAL.domain}`}>{LEGAL.domain}</a>. Al crear una cuenta y suscribirte, aceptas estos términos en su totalidad.
      </p>

      <h2>1. Quién presta el servicio</h2>
      <p>
        El servicio lo presta <strong>{LEGAL.legalName}</strong>, con domicilio en {LEGAL.country}. Contacto: <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>.
      </p>

      <h2>2. Qué es Strato</h2>
      <p>
        Strato es una herramienta de inteligencia artificial pensada para freelancers y profesionales creativos. Permite generar ofertas con varios paquetes, analizar potenciales clientes, escribir propuestas, detectar inflación de alcance y revisar pricing. Strato es una ayuda estratégica, no un asesoramiento legal, fiscal ni financiero.
      </p>

      <h2>3. Cuenta y elegibilidad</h2>
      <ul>
        <li>Debes ser mayor de 18 años para registrarte.</li>
        <li>Solo se permite una cuenta por persona física o jurídica.</li>
        <li>Eres responsable de mantener la confidencialidad de tu acceso a Google y de toda actividad realizada bajo tu cuenta.</li>
      </ul>

      <h2>4. Suscripción, precios y prueba gratuita</h2>
      <ul>
        <li><strong>Plan mensual:</strong> {LEGAL.pricingMonthly}.</li>
        <li><strong>Plan anual:</strong> {LEGAL.pricingYearly} (equivale a un descuento aproximado del 32% sobre el mensual).</li>
        <li><strong>Prueba gratuita:</strong> {LEGAL.trialDays} días al iniciar. Se solicita tarjeta al registrarse pero no se cobra nada durante la prueba.</li>
        <li><strong>Renovación:</strong> automática al final de cada periodo (mes o año) hasta que canceles.</li>
        <li><strong>Cancelación:</strong> puedes cancelar en cualquier momento desde tu portal de cliente. Si cancelas durante la prueba, no se te cobra nada.</li>
        <li><strong>Impuestos:</strong> los precios indicados pueden no incluir los impuestos aplicables según tu país de residencia. Stripe los calcula y muestra antes del pago.</li>
      </ul>

      <h2>5. Reembolsos</h2>
      <p>
        Dado el carácter digital del servicio y la prueba gratuita previa, no se realizan reembolsos por periodos parcialmente disfrutados. Si cancelas, conservas el acceso hasta el final del periodo ya pagado. Excepciones razonables (cobros duplicados, errores técnicos graves) se valoran caso a caso escribiendo a <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>.
      </p>

      <h2>6. Uso aceptable</h2>
      <p>No puedes usar Strato para:</p>
      <ul>
        <li>Generar contenido ilegal, fraudulento, ofensivo o que infrinja derechos de terceros.</li>
        <li>Hacer ingeniería inversa, scraping masivo o intentar romper el servicio.</li>
        <li>Revender automáticamente la salida de la IA como si fuera un servicio independiente.</li>
        <li>Subir información confidencial de clientes sin su consentimiento.</li>
      </ul>
      <p>Podemos suspender o cerrar tu cuenta si detectamos un uso indebido, sin reembolso.</p>

      <h2>7. Propiedad intelectual</h2>
      <ul>
        <li>Tu contenido (los textos que escribes y las ofertas que generas) es tuyo. Puedes usarlo comercialmente sin restricciones.</li>
        <li>El código, la marca y el diseño de Strato son propiedad de {LEGAL.legalName}.</li>
        <li>Al generar contenido con IA, eres responsable de revisarlo antes de enviarlo a tus clientes. La IA puede contener errores.</li>
      </ul>

      <h2>8. Limitación de responsabilidad</h2>
      <p>
        Strato se ofrece "tal cual". No garantizamos que las ofertas, precios o análisis generados sean acertados, completos o adecuados para tu caso concreto. {LEGAL.legalName} no se hace responsable de pérdidas comerciales derivadas del uso del servicio. La responsabilidad máxima en cualquier caso queda limitada al importe pagado en los últimos 12 meses.
      </p>

      <h2>9. Disponibilidad del servicio</h2>
      <p>
        Hacemos lo posible por mantener Strato disponible 24/7, pero pueden producirse interrupciones por mantenimiento, fallos de proveedores externos (Google, Stripe, Anthropic, MongoDB) o causas de fuerza mayor.
      </p>

      <h2>10. Modificaciones del servicio y los términos</h2>
      <p>
        Podemos modificar funcionalidades, precios o estos términos. Si los cambios son sustanciales o afectan al precio, te avisaremos por email al menos 30 días antes y podrás cancelar sin penalización antes de que entren en vigor.
      </p>

      <h2>11. Resolución de disputas y ley aplicable</h2>
      <p>
        Estos términos se rigen por la legislación de {LEGAL.country}. Cualquier disputa se intentará resolver primero amistosamente por email. Si no se llega a acuerdo, será competente la jurisdicción del domicilio del consumidor cuando aplique normativa de consumo, o los tribunales del domicilio del prestador en caso contrario.
      </p>

      <h2>12. Contacto</h2>
      <p>
        Para cualquier duda sobre estos términos: <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>.
      </p>
    </LegalPage>
  );
}
